<template>
    <div id="Register" class="card">
        <div class="card-header p-3 bg-white d-flex">
            <h5 class="modal-title popup-title flex-fill" id="ForgotPopupLabel">{{ $t('create_new_account') }}</h5>
            <button type="button" class="close-popup" aria-label="Close" @click="redirectTo('login')"></button>
        </div>
        <div class="card-body p-3">
            <div class="d-flex flex-column mb-3">
                <div class="line-status">
                    <div class="d-flex justify-content-between">
                        <div class="line"></div>
                        <div class="node active"></div>
                        <div class="node" :class="{ active: screen == 2 }"></div>
                    </div>
                </div>
                <Transition name="slide-fade" mode="out-in">
                    <div class="row g-3 align-items-center" v-if="screen == 1" :key="screen">
                        <div class="col-12">
                            <div class="form-group">
                                <label class="label-input">{{ $t('full_name') }}<span class="red">*</span></label>
                                <input type="text" :class="errors.fullname ? 'ito-input has-err' : 'ito-input'" name="fullname" :placeholder="$t('enter_your_full_name')" autocomplete="off" @input="addEvent1" v-model="user.fullname"
                                    @keyup.enter="valid_1 && changeScreen(2)" />
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="form-group">
                                <label class="label-input">{{ $t('grade') }}<span class="red">*</span></label>
                                <select class="ito-input" name="grade" v-model="user.grade" :title="$t('choose_a_grade')" @change="addEvent1" @keyup.enter="valid_1 && changeScreen(2)">
                                    <option value="">
                                        {{ $t('choose_a_grade') }}
                                    </option>
                                    <option :value="grade" v-for="grade in configs.grades">{{ `${$t('grade')} ${grade}` }}</option>
                                </select>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="form-group">
                                <label class="label-input">{{ $t('phone_name') }}</label>
                                <input type="text" :class="errors.phone ? 'ito-input has-err' : 'ito-input'" name="phone" :placeholder="$t('enter_your_phone_number')" autocomplete="off" @input="addEvent1" v-model="user.phone" id="phone"
                                    @keyup.enter="valid_1 && changeScreen(2)" />
                            </div>
                        </div>

                        <div class="col-6">
                            <div class="form-group">
                                <label class="label-input">{{ $t('gender') }}</label>
                                <select class="ito-input" name="gender" v-model="user.gender" title="Choose your gender" @change="addEvent1">
                                    <option value="">
                                        {{ $t('choose_a_gender') }}
                                    </option>
                                    <option value="male">
                                        {{ $t('male') }}
                                    </option>
                                    <option value="female">
                                        {{ $t('female') }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label class="label-input">{{ $t('date_of_birth') }}</label>
                                <input readonly="true" type="text" class="date datepicker birthday" :class="errors.birthday ? 'ito-input has-err' : 'ito-input'" name="birthday" :placeholder="$t('birthday')" autocomplete="off" v-model="user.birthday"
                                    @keyup.enter="valid_1 ? changeScreen(2) : ''" />
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label class="label-input">{{ $t('province') }}<span class="red">*</span></label>
                                <select class="ito-input" name="province" v-model="user.province_id" :title="$t('choose_province')" @change="addEvent1" @keyup.enter="valid_1 && changeScreen(2)">
                                    <option :value="null">
                                        {{ $t('choose_province') }}
                                    </option>
                                    <option :value="province.id" v-for="province in provinceOptions">{{ province.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label class="label-input">{{ $t('ward') }}<span class="red">*</span></label>
                                <select class="ito-input" name="ward" v-model="user.ward_id" :title="$t('choose_ward')" @change="addEvent1" @keyup.enter="valid_1 && changeScreen(2)">
                                    <option :value="null">
                                        {{ $t('choose_ward') }}
                                    </option>
                                    <option :value="ward.id" v-for="ward in wardOptions">{{ ward.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="error-message text-center" v-if="errors.fullname">{{ errors.fullname }}</div>
                        <div class="error-message text-center" v-if="errors.phone">{{ errors.phone }}</div>
                        <div class="error-message text-center" v-if="errors.gender">{{ errors.gender }}</div>
                        <div class="error-message text-center" v-if="errors.birthday">{{ errors.birthday }}</div>
                        <div class="error-message text-center" v-if="errors.grade">{{ errors.grade }}</div>
                    </div>
                    <div class="row g-3 align-items-center" v-if="screen == 2" :key="screen">
                        <div class="col-12">
                            <div class="form-group">
                                <label class="label-input">{{ $t('username') }}<span class="red">*</span></label>
                                <!--<input type="text" class="ito-input" placeholder="Enter your username (6-15 characters)">-->
                                <input type="text" :class="errors.username ? 'ito-input has-err' : 'ito-input'" name="username" :placeholder="$t('enter_your_username_8_15_characters')" autocomplete="off" @input="addEvent2" v-model="user.username"
                                    @keyup.enter="valid_2 && onSubmit()" />
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <label class="label-input">{{ $t('e_mail') }}<span class="red">*</span></label>
                                <input type="text" :class="errors.email ? 'ito-input has-err' : 'ito-input'" name="email" :placeholder="$t('enter_your_e_mail')" autocomplete="off" @input="addEvent2" v-model="user.email"
                                    :readonly="payload?.email ? true : false" @keyup.enter="valid_2 && onSubmit()" />
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <label class="label-input">{{ $t('password') }}<span class="red">*</span></label>
                                <div class="input-pass">
                                    <input :type="showPass ? 'text' : 'password'" :class="errors.password ? 'ito-input has-err' : 'ito-input'" id="password-field" name="password" :placeholder="$t('enter_your_password')" autocomplete="off"
                                        @input="addEvent2" v-model="user.password" @keyup.enter="valid_2 && onSubmit()" />
                                    <span :class="[showPass ? 'icon-eye eye-show' : 'icon-eye eye-hide']" @click="showPass = !showPass"></span>
                                </div>
                                <label class="label-input" style="margin-top: 10px">{{ $t('confirm_the_password') }}<span class="red">*</span></label>
                                <div class="input-pass">
                                    <input :type="showConfirm ? 'text' : 'password'" :class="errors.password_confirm ? 'ito-input has-err' : 'ito-input'" id="password-confirm" name="password_confirm" :placeholder="$t('enter_your_password_again')"
                                        autocomplete="off" @input="addEvent2" v-model="user.password_confirm" @keyup.enter="valid_2 && onSubmit()" />
                                    <span :class="[showConfirm ? 'icon-eye eye-show' : 'icon-eye eye-hide']" @click="showConfirm = !showConfirm"></span>
                                </div>
                            </div>
                            <div class="error-message text-center" v-if="errors.username">{{ errors.username }}</div>
                            <div class="error-message text-center" v-if="errors.email">{{ errors.email }}</div>
                            <div class="error-message text-center" v-if="errors.password">{{ errors.password }}</div>
                            <div class="error-message text-center" v-if="errors.password_confirm">{{
                                errors.password_confirm }}
                            </div>
                        </div>
                    </div>
                </Transition>
            </div>
            <p class="support-link-bottom">{{ $t('contact_hotline') }} <br />
                <b>1900 088 893 (Hà Nội) - 1900 088 893 (TP. Hồ Chí Minh)</b>
            </p>
        </div>
        <div class="card-footer d-flex justify-content-around bg-white gap-3 p-3">
            <button type="button" class="ito-btn ito-btn-primary ito-btn-lg" :disabled="!valid_1" @click="changeScreen(2)" v-if="screen == 1">{{ $t('next') }} </button>
            <button type="button" class="ito-btn ito-btn-light ito-btn-lg" @click="changeScreen(1)" v-if="screen == 2">{{ $t('back') }}</button>
            <button type="button" class="ito-btn ito-btn-primary ito-btn-lg" :disabled="!valid_2" @click="onSubmit()" v-if="screen == 2">{{ $t('next') }}
            </button>
        </div>

        <!-- Modals-->
        <div class="modal fade" id="RegisterSuccessPopup" tabindex="-1" aria-labelledby="RegisterSuccessPopupLabel" aria-hidden="true" data-bs-backdrop="static" data-keyboard=false>
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-0">
                        <h5 class="modal-title popup-title flex-fill text-center" id="RegisterSuccessPopupLabel">{{ $t('congratulation') }}</h5>
                    </div>
                    <div class="modal-body px-3">
                        <h6 class="text-center">{{ $t('text_register_success') }}</h6>
                    </div>
                    <div class="modal-footer d-flex flex-column justify-content-center border-0">
                        <button @click="redirectTo('upgrade_account')" class="btn ito-btn-primary px-5" data-bs-dismiss="modal">
                            {{ $t('upgrade_account') }}
                        </button>
                        <button type="button" @click="redirectTo('home')" class="btn ito-btn-outline-primary px-5" data-bs-dismiss="modal">
                            {{ $t('go_to_home') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <validate-modal :err_code="error_code" />

        <div class="modal fade" id="UpgradeAccountPopup" tabindex="-1" role="dialog" aria-labelledby="UpgradeAccountPopup" aria-hidden="true" data-bs-backdrop="static" data-keyboard=false>
            <div class="modal-dialog modal-dialog-centered ito-popup-large" role="document">
                <div class="modal-content box-shadow-main">
                    <div class="close-popup" data-bs-dismiss="modal"></div>
                    <h3 class="popup-title mb-20">Unclock full access 23</h3>
                    <div class="select-upgrade-type d-flex mb-20">
                        <div class="package package-1 box-shadow-main">
                            <div class="package-title">PLUS ACCOUNT</div>
                            <div class="package-price">75,000 vnđ / tháng</div>
                            <div class="package-content">
                                <div class="package-items d-flex">
                                    <img src="/themes/ito/images/tick-1.svg">
                                    <div class="package-items-text">iSmart Maths & Science: Vocabulary,
                                        Presentation, Practices.
                                    </div>
                                </div>
                                <div class="package-items d-flex">
                                    <img src="/themes/ito/images/tick-1.svg">
                                    <div class="package-items-text">iSmart Maths & Science: Fact Reading, Home
                                        Science, 4-skill Extended.
                                    </div>
                                </div>
                                <div class="package-items d-flex">
                                    <img src="/themes/ito/images/tick-1.svg">
                                    <div class="package-items-text">General English: much more content than
                                        STANDARD
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="package package-2 box-shadow-main">
                            <div class="package-title">PRO ACCOUNT</div>
                            <div class="package-price">199,000 vnđ / tháng</div>
                            <div class="package-content package-content-2">
                                <div class="package-items d-flex">
                                    <img src="/themes/ito/images/tick-2.svg">
                                    <div class="package-items-text">iSmart Maths & Science: Vocabulary,
                                        Presentation, Practices.
                                    </div>
                                </div>
                                <div class="package-items d-flex">
                                    <img src="/themes/ito/images/tick-2.svg">
                                    <div class="package-items-text">iSmart Maths & Science: Fact Reading, Home
                                        Science, 4-skill Extended.
                                    </div>
                                </div>
                                <div class="package-items d-flex">
                                    <img src="/themes/ito/images/tick-2.svg">
                                    <div class="package-items-text">General English: much more content than
                                        STANDARD.
                                    </div>
                                </div>
                                <div class="package-items d-flex">
                                    <img src="/themes/ito/images/tick-2.svg">
                                    <div class="package-items-text">IGS-Bridge</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group d-flex justify-content-center">
                        <div class="ito-btn-large">Upgrade account</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { authRegister, authAnonymous } from '../../models/auth'
import ValidateModal from '../modal/ValidateModal.vue';
import { mapGetters } from 'vuex'
import { parseJwt } from '../..//utils/utils';
import { cloneDeep } from 'lodash';

export default {
    name: "Register",
    data() {
        const urlParams = new URLSearchParams(window.location.search)
        const token = urlParams.get('token')
        const payload = parseJwt(token)

        return {
            errors: {
                username: '',
                fullname: '',
                phone: '',
                email: '',
                gender: '',
                birthday: '',
                grade: '',
                province: '',
                ward: '',
                password: '',
                password_confirm: ''
            },
            user: {
                username: '',
                fullname: payload?.name ?? '',
                phone: '',
                email: payload?.email ?? '',
                gender: '',
                birthday: '',
                grade: '',
                password: '',
                password_confirm: '',
                province_id: null,
                ward_id: null
            },
            showPass: false,
            showConfirm: false,
            screen: 1,
            valid_1: false,
            valid_2: false,
            error_code: '',
            payload,
            provinceOptions: [],
            wardOptions: [],
        };
    },

    created() {
        this.fetch()
    },

    computed: {
        ...mapGetters([
            'user_info'
        ], () => {
            if (this.user_info) {
                return this.user_info
            }

            return this.user
        }),

        configs() {
            return this.$store.state.configs
        },
    },
    watch: {
        configs: {
            handler(cfg) {
                this.provinceOptions = cfg?.provinces || [];
            },
            immediate: true,
            deep: true
        },

        'user.province_id': {
            handler(value) {
                this.wardOptions = this.provinceOptions.find(p => (p.id == value))?.Ward || [];
                if (!this.wardOptions.find(w => w.id === this.user.ward_id?.id)) {
                    this.user.ward_id = null;
                }
            },
            immediate: true
        }
    },

    components: {
        ValidateModal
    },

    methods: {
        fetch() {
            this.$nextTick(function () {
                $('.birthday').datepicker({
                    dateFormat: 'dd/mm/yy',
                    changeMonth: true,
                    changeYear: true,
                    showOtherMonths: true,
                    selectOtherMonths: false,
                    yearRange: '1900:+0',
                    maxDate: new Date(),
                    monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
                }).on('change', (e) => {
                    this.addEvent1(e);
                });
            });
        },

        formatDate(input) {
            return input.split("/").reverse().join("-")
        },

        changeScreen($screen) {
            this.screen = $screen;
        },

        addEvent1({ target }) {
            switch (target.name) {
                case 'fullname':
                    this.user.fullname = target.value;
                    break;
                case 'phone':
                    this.user.phone = target.value;
                    break;
                case 'gender':
                    this.user.gender = target.value;
                    break;
                case 'birthday':
                    this.user.birthday = target.value;
                    break;
                case 'grade':
                    this.user.grade = target.value;
                    break;
                case 'province':
                    this.user.province_id = target.value;
                    break;
                case 'ward':
                    this.user.ward_id = target.value;
                    break;
            }

            if (this.eventValid1({ target })
                && this.user.fullname != ''
                && this.user.grade != ''
                && this.user.province_id
                && this.user.ward_id
            ) {
                this.valid_1 = true;
            } else {
                this.valid_1 = false;
            }
        },

        addEvent2({ target }) {
            switch (target.name) {
                case 'username':
                    this.user.username = target.value;
                    break;
                case 'email':
                    this.user.email = target.value;
                    break;
                case 'password':
                    this.user.password = target.value;
                    break;
                case 'password_confirm':
                    this.user.password_confirm = target.value;
                    break;
            }
            if (!this.eventValid2({ target })) {
                this.valid_2 = false;
                return false;
            }
            if (this.eventValid2({ target })
                && this.user.username != ''
                && this.user.email != ''
                && this.user.password != ''
                && this.user.password_confirm != '') {
                this.valid_2 = true;
            } else {
                this.valid_2 = false;
            }
        },

        eventValid1({ target }) {
            let is_valid = true;
            switch (target.name) {
                case 'fullname':
                    this.errors.fullname = '';
                    if (this.user.fullname == '') {
                        this.errors.fullname = this.$i18n.t('fullname_is_not_empty');
                        is_valid = false;
                    }
                    if (this.regexSpecialChar(this.user.fullname)) {
                        this.errors.fullname = this.$i18n.t('fullname_must_not_contain_special_characters');
                        is_valid = false;
                    }
                    break;
                case 'phone':
                    this.errors.phone = '';
                    if (this.isNumeric(this.user.phone) == false && this.user.phone != '') {
                        this.errors.phone = this.$i18n.t('phone_number_not_contain_special_characters_and_characters');
                        is_valid = false;
                    }
                    if (this.user.phone.length > 10) {
                        this.errors.phone = this.$i18n.t('phone_number_invalid');
                        is_valid = false;
                    }
                    break;
                case 'grade':
                    this.errors.grade = '';
                    if (this.user.grade == '') {
                        this.errors.grade = this.$i18n.t('choose_a_grade');
                        is_valid = false;
                    }
                    break;
                case 'province':
                    this.errors.province = '';
                    if (this.user.province_id == '') {
                        this.errors.province = this.$i18n.t('choose_province');
                        is_valid = false;
                    }
                    break;
                case 'ward':
                    this.errors.ward = '';
                    if (this.user.ward_id == '') {
                        this.errors.ward = this.$i18n.t('choose_ward');
                        is_valid = false;
                    }
                    break;
            }
            return is_valid;
        },

        eventValid2({ target }) {
            let is_valid = true;
            if (this.user.username.length < 8 ||
                this.user.username.length > 15 ||
                this.regexSpecialChar(this.user.username) ||
                this.validateVietnameseChar(this.user.username) ||
                !this.validateEmail(this.user.email) ||
                this.user.password == '' ||
                this.user.password.length < 8 ||
                this.validateVietnameseChar(this.user.password) ||
                this.user.password_confirm == '' ||
                this.user.password_confirm != this.user.password
            ) {
                is_valid = false;
            }


            switch (target.name) {
                case 'username':
                    this.errors.username = '';
                    if (this.user.username.length < 8 || this.user.username.length > 15) {
                        this.errors.username = this.$i18n.t('enter_your_username_8_15_characters');
                    }
                    if (this.regexSpecialChar(this.user.username)) {
                        this.errors.username = this.$i18n.t('the_username_you_entered_is_invalid');
                    }
                    if (this.validateVietnameseChar(this.user.username)) {
                        this.errors.username = this.$i18n.t('the_username_you_entered_is_invalid');
                    }
                    break;
                case 'email':
                    this.errors.email = '';
                    if (!this.validateEmail(this.user.email)) {
                        this.errors.email = this.$i18n.t('email_is_not_constrain_email_format');
                    }
                    break;
                case 'password':
                    this.errors.password = '';
                    if (this.user.password == '') {
                        this.errors.password = this.$i18n.t('password_cannot_be_empty');
                    }
                    if (this.user.password.length < 8) {
                        this.errors.password = this.$i18n.t('password_at_least_8_characters');
                    }
                    if (this.validateVietnameseChar(this.user.password)) {
                        this.errors.password = this.$i18n.t('password_invalid_regex');
                    }
                    if (this.user.password_confirm != '' && this.user.password_confirm != this.user.password) {
                        this.errors.password_confirm = this.$i18n.t('password_confirm_invalid');
                    }
                    break;
                case 'password_confirm':
                    this.errors.password_confirm = '';
                    if (this.user.password_confirm == '') {
                        this.errors.password_confirm = this.$i18n.t('password_confirm_is_not_empty');
                    }
                    if (this.user.password_confirm != this.user.password) {
                        this.errors.password_confirm = this.$i18n.t('password_confirm_invalid');
                    }
                    break;
            }
            return is_valid;
        },

        isNumeric(value) {
            return /^\d+$/.test(value);
        },

        validateEmail(value) {
            let is_valid = false;
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
                is_valid = true;
            }
            return is_valid;
        },

        onSubmit() {
            const that = this;
            const params = cloneDeep(this.user)
            params.birthday = this.formatDate(params.birthday)
            delete params.password_confirm
            if (that.user_info && that.user_info.student_type == 2) {
                authAnonymous(params).then((data) => {
                    that.$store.commit("setLoading", false);
                    if (data.data.code == 0) {
                        $('#RegisterSuccessPopup').modal('show');
                        that.$store.commit('setAuth', true);
                        localStorage.removeItem('checkedSubjects');
                    }
                    else {
                        that.error_code = data.data.msg;
                        $('#getValidateModal').modal('show');
                    }
                }).catch(() => {
                    that.$store.commit("setLoading", false);
                    that.error_code = data.data.msg;
                    $('#getValidateModal').modal('show');
                });
            } else {
                authRegister(params).then((data) => {
                    that.$store.commit("setLoading", false);
                    if (data.data.code == 0) {
                        $('#RegisterSuccessPopup').modal('show');
                        that.$store.commit('setAuth', true);
                        localStorage.setItem('access_token', data.data.results.access_token);
                        localStorage.removeItem('checkedSubjects');
                    }
                    else {
                        that.error_code = data.data.msg;
                        $('#getValidateModal').modal('show');
                    }
                }).catch(() => {
                    that.$store.commit("setLoading", false);
                    that.error_code = data.data.msg;
                    $('#getValidateModal').modal('show');
                });
            }
        },

        regexSpecialChar(txt) {
            var specialRegex = /[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/;
            if (txt.match(specialRegex)) {
                return true;
            }
            return false;
        },

        validateVietnameseChar(value) {
            var reGex = /[àÀảẢãÃáÁạẠăĂằẰẳẲẵẴắẮặẶâÂầẦẩẨẫẪấẤậẬđĐèÈẻẺẽẼéÉẹẸêÊềỀểỂễỄếẾệỆìÌỉỈĩĨíÍịỊòÒỏỎõÕóÓọỌôÔồỒổỔỗỖốỐộỘơƠờỜởỞỡỠớỚợỢùÙủỦũŨúÚụỤưƯừỪửỬữỮứỨựỰỳỲỷỶỹỸýÝỵỴ ]/;
            if (value.match(reGex)) {
                return true;
            }
            return false;
        },

        redirectTo(route) {
            $('.modal').modal('hide')
            this.$router.push({ name: route });
        }
    }
}
</script>

<style scoped>
.ito-input {
    width: 100%;
}


.form-control[readonly] {
    background-color: #ffffff;
}

input[name="email"][readonly] {
    background-color: #E0E0E0;
}

#Register {
    position: relative;
    width: 550px;
    background: #ffffff;
    margin: auto;
    padding: 20px;
    box-shadow: 4px 4px 0px rgba(0, 0, 0, 0.07), inset 0px 4px 0px rgba(231, 231, 231, 0.25);
    border-radius: 8px;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.1s linear;
}

.slide-fade-enter {
    transform: translateX(50px);
    opacity: 0;
}

.slide-fade-leave-to {
    transform: translateX(-50px);
    opacity: 0;
}

.support-link-bottom {
    color: #1F9FFC;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
}
</style>